import { useMonyawn } from "../../../context/MonyawnContext";

const confidenceTone = {
  low: "text-red-700 bg-red-50 border-red-100",
  medium: "text-amber-700 bg-amber-50 border-amber-100",
  high: "text-emerald-700 bg-emerald-50 border-emerald-100",
};

export function AiAutopilotPanel() {
  const { recommendation, automationPlan, integrationHealth, frictionSnapshot } = useMonyawn();

  if (!recommendation) {
    return null;
  }

  return (
    <section className="rounded-[1.75rem] border border-black/5 bg-white/70 shadow-brand-shadow p-5">
      <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-accent">
        AI autopilot
      </p>

      <div className="mt-3 flex items-center justify-between gap-3">
        <h3 className="text-base font-bold text-brand-ink tracking-[-0.02em]">
          {recommendation.primaryAction}
        </h3>
        <span
          className={`px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-[0.12em] border ${confidenceTone[recommendation.confidence]}`}
        >
          {recommendation.confidence}
        </span>
      </div>
      <p className="mt-2 text-sm text-brand-muted leading-relaxed">{recommendation.rationale}</p>

      <div className="mt-4 space-y-3">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand-muted">
            Missing evidence
          </p>
          {recommendation.missingEvidence.length === 0 ? (
            <p className="text-xs text-brand-ink mt-2">No critical gaps detected.</p>
          ) : (
            <ul className="mt-2 space-y-1">
              {recommendation.missingEvidence.slice(0, 3).map((item) => (
                <li key={item} className="text-xs text-brand-ink">
                  • {item}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand-muted">
            Automation queue
          </p>
          {automationPlan.length === 0 ? (
            <p className="text-xs text-brand-ink mt-2">No automations ready yet.</p>
          ) : (
            <ul className="mt-2 space-y-2">
              {automationPlan.slice(0, 3).map((plan) => (
                <li key={plan.id} className="rounded-xl border border-black/8 bg-white/70 p-2.5">
                  <p className="text-xs font-semibold text-brand-ink">{plan.title}</p>
                  <p className="text-[10px] text-brand-muted mt-1">
                    Trigger: {plan.trigger} · Mode: {plan.executionMode}
                  </p>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand-muted">
            Connector health
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            {integrationHealth.map((item) => (
              <span
                key={item.id}
                className="px-2 py-1 rounded-full bg-brand-highlight/20 border border-brand-highlight/40 text-[10px] font-semibold text-brand-ink"
              >
                {item.label}: {item.status}
              </span>
            ))}
          </div>
        </div>

        <div className="rounded-xl border border-black/8 bg-white/70 p-3">
          <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand-muted">
            Friction map
          </p>
          <p className="text-xs text-brand-ink mt-2">
            {frictionSnapshot.totalActions} tracked actions · {frictionSnapshot.repetitiveActions}{" "}
            repetitive · {frictionSnapshot.manualHeavyActions} manual-heavy
          </p>
        </div>
      </div>
    </section>
  );
}
